(() => {
  const data = document.getElementById('ca-navigation-copy');
  if (!data) return;
  const copy = JSON.parse(data.textContent);
  const scopes = 'header, #header-group, footer, [role="contentinfo"], .ca-language-strip, product-recommendations, [id*="product_recommendations"]';
  function translate(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const changes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement.closest('script,style,textarea,input')) continue;
      const trimmed = node.textContent.trim();
      const key = Object.keys(copy).find(key => key.toLowerCase() === trimmed.toLowerCase());
      if (key && copy[key] !== trimmed) changes.push([node, node.textContent.replace(trimmed, copy[key])]);
    }
    changes.forEach(([node, value]) => { node.textContent = value; });
  }
  function run() {
    document.querySelectorAll(scopes).forEach(translate);
    const locale = document.documentElement.lang || 'en';
    if (locale.toLowerCase() === 'en') return;
    const names = new Intl.DisplayNames([locale], {type:'language'});
    document.querySelectorAll('a[href*="/collections/lang-"], a[href*="/pages/books-in-"]').forEach(a => {
      const code = a.getAttribute('href').match(/(?:lang-|books-in-)([a-z-]+)/i)?.[1];
      if (!code) return;
      if (/^Books in /.test(a.getAttribute('aria-label') || '')) {
        a.setAttribute('aria-label', copy.Books+': '+names.of(code));
        if (a.hasAttribute('title')) a.setAttribute('title', names.of(code));
      }
      const walker = document.createTreeWalker(a, NodeFilter.SHOW_TEXT);
      while(walker.nextNode()) {
        const node=walker.currentNode;
        if (/Books in [A-Za-z]+(?: [A-Za-z]+)*/.test(node.textContent)) node.textContent=node.textContent.replace(/Books in [A-Za-z]+(?: [A-Za-z]+)*/,copy.Books+': '+names.of(code));
      }
    });
  }
  run();
  document.addEventListener('shopify:section:load', run);
  // The language strip and recommendations may mount after deferred scripts.
  // Text-only changes made above do not trigger another translation pass.
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1))) run();
  }).observe(document.body, {childList:true, subtree:true});
})();
